module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui stackable equal width grid"
  }, [_c('div', {
    staticClass: "equal width row primary"
  }, [_c('div', {
    staticClass: "middle aligned column"
  }, [_c('a', {
    attrs: {
      "href": "http://www.coindesk.com/dao-manager-aragon-alpha-ethereum/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    staticClass: "ui fluid tiny centered image",
    attrs: {
      "src": require("../assets/media/coindesk.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned column"
  }, [_c('a', {
    attrs: {
      "href": "https://www.financemagnates.com/cryptocurrency/news/dao-reborn-aragon-launches-crowdsale-decentralized-organizations/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    staticClass: "ui fluid tiny centered image",
    attrs: {
      "src": require("../assets/media/financemagnates.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned column"
  }, [_c('a', {
    attrs: {
      "href": "https://www.forbes.com/sites/rogeraitken/2017/04/20/forbes-under-30-tech-prodigy-in-cryptosale-for-decentralized-jurisdiction-platform/#3ac1df126a12",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    staticClass: "ui fluid tiny centered image",
    attrs: {
      "src": require("../assets/media/forbes.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned column"
  }, [_c('a', {
    attrs: {
      "href": "https://cointelegraph.com/news/spains-aragon-joins-ethereum-startups-eyeing-token-sale-glory",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    staticClass: "ui fluid tiny centered image",
    attrs: {
      "src": require("../assets/media/cointelegraph.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned column"
  }, [_c('a', {
    attrs: {
      "href": "https://finance.yahoo.com/m/12f8484f-3af2-370d-b6e7-f2cada14bf5f/forbes-%27under-30%27-tech.html",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    staticClass: "ui fluid tiny centered image",
    attrs: {
      "src": require("../assets/media/yahoo.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "middle aligned column"
  }, [_c('a', {
    attrs: {
      "href": "http://coinjournal.net/ethereum-platform-aragon-power-next-gen-decentralized-organizations/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    staticClass: "ui fluid tiny centered image",
    attrs: {
      "src": require("../assets/media/coinjournal.png")
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5597f080"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Media.vue
// module id = 513
// module chunks = 1